import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=3de4b966"
import script from "./Medias.vue?vue&type=script&lang=ts"
export * from "./Medias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports